<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Timeline" pageTitle="Timeline" />
            <TimelineContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import TimelineContent from '../Timeline/TimelineContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'TimelinePage',
    components: {
        MainHeader,
        PageTitle,
        TimelineContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>